import { app } from 'app/app';
import { user } from 'app/user';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { MasterLayout } from 'layout/master/main';
import { CompanyHeader } from 'module/companyHeader/main';
import { CompanyLocationList } from 'module/companyLocationList/main';
import { CompanyInteractiveMap } from 'module/companyInteractiveMap/main';
import { AppController } from 'app/controller';
import './styles.scss';

class CompanyLocations extends AppController {
    domBindings() {
        return {
            companyHeader: '.m-companyHeader',
            companyLocationList: '.m-companyLocationList',
            companyInteractiveMap: '.m-companyInteractiveMap',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.companyHeader = new CompanyHeader(this.dom.companyHeader);
        this.companyLocationList = new CompanyLocationList(this.dom.companyLocationList);
        this.companyInteractiveMap = new CompanyInteractiveMap(this.dom.companyInteractiveMap);
    }

    subEvents() {
        if (!user.isLoggedIn()) {
            userCompanyFollow.events.on('onUnauthorized', (followObject) => {
                this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
            });
        }
    }
}

app.boot(CompanyLocations);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(CompanyLocations);
    });

    module.hot.accept(() => {});
}
